import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgForward({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.02v-.04a.993.993 0 00-.01-.129l-.01-.052a1.007 1.007 0 00-.176-.394l-.01-.013a1.023 1.023 0 00-.087-.1l.08.091-.029-.036.03.036a.997.997 0 00-.08-.09l-9.001-9a1 1 0 00-1.498 1.32l.084.094L18.587 11H3a1 1 0 00-.993.883L2 12a1 1 0 00.884.993L3 13h15.586l-7.293 7.293a1 1 0 00-.084 1.32l.084.094a1 1 0 001.414 0l9-9a1.021 1.021 0 00.257-.441.981.981 0 00.025-.118l.008-.066.001-.023.001-.005.001-.035zm-.293-.727c.036.035.068.073.097.112l-.028-.035-.069-.077z"
        fill={color}
      />
    </svg>
  )
}

export default SvgForward
